// Ash: hide carousel arrows when the row has no horizontal overflow.
//
// Why a dedicated script instead of the theme's built-in
// `auto-hide-controls` attribute:
//   1. The theme's #updateControlsVisibility only toggles
//      <slideshow-controls> (dots wrapper) — NOT <slideshow-arrows>.
//   2. After product-recommendations injects HTML via morphSection,
//      the slideshow-component's ResizeObserver may run with stale
//      measurements (scrollWidth = 0 before slides render).
//   3. base.css has an `arrowsSlideIn` opacity animation that runs
//      on slideshow-component:hover regardless of any `hidden`
//      attribute on the arrows wrapper, so arrows reappear on hover.
//
// This script puts a `.ash-no-overflow` class on every
// `.resource-list__carousel` whose inner scroller has scrollWidth
// <= clientWidth (with a 2px tolerance for sub-pixel rounding).
// The matching CSS in resource-list-carousel.liquid hides the arrows
// while that class is present.
(function () {
  if (window.__ashCarouselArrowHiderInit) return;
  window.__ashCarouselArrowHiderInit = true;

  var SELECTOR = '.resource-list__carousel';
  var CLASS = 'ash-no-overflow';
  var TOLERANCE = 2; // px — accept tiny sub-pixel diffs as "no overflow"

  function getScroller(carousel) {
    // The theme's slideshow scroller has ref="scroller". In compiled
    // output that becomes attribute `ref="scroller"` on a generic
    // element inside slideshow-component. Fall back to slideshow-slides
    // and finally the carousel itself.
    return (
      carousel.querySelector('[ref="scroller"]') ||
      carousel.querySelector('slideshow-slides') ||
      carousel
    );
  }

  function check(carousel) {
    var scroller = getScroller(carousel);
    if (!scroller) return;
    var sw = scroller.scrollWidth;
    var cw = scroller.clientWidth || scroller.offsetWidth;
    // Guard against zero-width measurements during early layout —
    // those would falsely report "no overflow".
    if (!cw) return;
    var overflows = sw - cw > TOLERANCE;
    carousel.classList.toggle(CLASS, !overflows);
  }

  function checkAll(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(check);
  }

  function observeCarousel(carousel) {
    if (carousel.__ashOverflowObs) return;
    var scroller = getScroller(carousel);
    if (!scroller) return;
    try {
      var ro = new ResizeObserver(function () {
        check(carousel);
      });
      ro.observe(scroller);
      if (scroller !== carousel) ro.observe(carousel);
      carousel.__ashOverflowObs = ro;
    } catch (e) {
      // ResizeObserver not supported — fall back to window resize listener.
    }
    check(carousel);
  }

  function wireAll(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(observeCarousel);
  }

  function start() {
    wireAll(document);

    // Catch carousels injected later (product-recommendations,
    // theme editor reloads, predictive search, etc.).
    new MutationObserver(function (muts) {
      var anyRelevant = false;
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (
            (n.matches && n.matches(SELECTOR)) ||
            (n.querySelector && n.querySelector(SELECTOR))
          ) {
            anyRelevant = true;
            break;
          }
        }
        if (anyRelevant) break;
      }
      if (anyRelevant) {
        // Delay so child elements & their layout settle first.
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            wireAll(document);
          });
        });
      }
    }).observe(document.documentElement, { childList: true, subtree: true });

    // Belt-and-suspenders re-check on a few well-known events.
    window.addEventListener('resize', function () { checkAll(); }, { passive: true });
    window.addEventListener('load', function () { checkAll(); });
    document.addEventListener('shopify:section:load', function (e) {
      wireAll(e.target);
    });

    // Brief settle for lazy image layout; MO + resize + section:load
    // handle the rest without a long poll storm.
    var ticks = 0;
    var poll = setInterval(function () {
      checkAll();
      if (++ticks > 8) clearInterval(poll);
    }, 400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
